import request from "./../utils/request";

export function getBannedWords(limit = 1000, page = 1) {
    return request({
        url: `/bannedWords/pagination`,
        method: "get",
        params: {
            pageCount: Math.max(page, 1),
            perPage: Math.max(limit, 0),
        },
    });
}

export function createBannedWord(data) {
    return request({
        url: "/bannedWords/",
        method: "post",
        data: data,
        headers: {
            "x-permission": "bannedWords.create",
        },
    });
}

export function updateBannedWord(id, data) {
    return request.put(`/bannedWords/${id}`, data);
}

export function deleteBannedWord(id) {
    return request.delete(`/bannedWords/${id}`);
}
